"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditMyProfileError = exports.PaymentIntentError = exports.ResetPasswordLinkError = exports.EditPasswordError = exports.AccessTokenError = exports.UserRegistrationStatus = void 0;
var UserRegistrationStatus;
(function (UserRegistrationStatus) {
    UserRegistrationStatus["Registered"] = "Registered";
    UserRegistrationStatus["Unknown"] = "Unknown";
})(UserRegistrationStatus || (exports.UserRegistrationStatus = UserRegistrationStatus = {}));
var AccessTokenError;
(function (AccessTokenError) {
    AccessTokenError["PasswordDoNotMatch"] = "PasswordDoNotMatch";
    AccessTokenError["UserAlreadyExistsWithOrganization"] = "UserAlreadyExistsWithOrganization";
    AccessTokenError["ResetTokenDoNotMatch"] = "ResetTokenDoNotMatch";
    AccessTokenError["NoDonorAllowedOnMobileApp"] = "NoDonorAllowedOnMobileApp";
    AccessTokenError["EmailDoesNotExist"] = "EmailDoesNotExist";
    AccessTokenError["UrlInvalid"] = "UrlInvalid";
    AccessTokenError["StytchOrganizationIdNotFound"] = "StytchOrganizationIdNotFound";
    AccessTokenError["EmailOrPasswordNotSent"] = "EmailOrPasswordNotSent";
    AccessTokenError["ErrorCreatingAccessToken"] = "error_creating_access_token";
    AccessTokenError["ErrorOnOrganizationCreation"] = "error_on_organization_creation";
    AccessTokenError["UserNotFoundWithOrganization"] = "user_not_found_with_organization";
    AccessTokenError["TokenDoesNotMatch"] = "TokenDoesNotMatch";
    AccessTokenError["EmailNotSent"] = "EmailNotSent";
    AccessTokenError["InvalidCharityNumber"] = "InvalidCharityNumber";
    AccessTokenError["TwoFactorCodeExpired"] = "TwoFactorCodeExpired";
    AccessTokenError["TwoFactorCodeDoesNotMatch"] = "TwoFactorCodeDoesNotMatch";
    AccessTokenError["GoogleTokenInvalid"] = "GoogleTokenInvalid";
    AccessTokenError["UnauthorizedToken"] = "UnauthorizedToken";
    AccessTokenError["InvalidOrganizationName"] = "InvalidOrganizationName";
    AccessTokenError["UserShouldAuthenticateWithGoogleSSO"] = "UserShouldAuthenticateWithGoogleSSO";
    AccessTokenError["AppleTokenInvalid"] = "AppleTokenInvalid";
})(AccessTokenError || (exports.AccessTokenError = AccessTokenError = {}));
var EditPasswordError;
(function (EditPasswordError) {
    EditPasswordError["UserNotFound"] = "UserNotFound";
    EditPasswordError["UserEmailNotFound"] = "UserEmailNotFound";
    EditPasswordError["WrongOldPassword"] = "WrongOldPassword";
    EditPasswordError["UserNotOnStytch"] = "UserNotOnStytch";
})(EditPasswordError || (exports.EditPasswordError = EditPasswordError = {}));
var ResetPasswordLinkError;
(function (ResetPasswordLinkError) {
    ResetPasswordLinkError["EmailDoesNotExist"] = "EmailDoesNotExist";
})(ResetPasswordLinkError || (exports.ResetPasswordLinkError = ResetPasswordLinkError = {}));
var PaymentIntentError;
(function (PaymentIntentError) {
    PaymentIntentError["OwnerNotFound"] = "OwnerNotFound";
    PaymentIntentError["UnknownError"] = "UnknownError";
    PaymentIntentError["FormNotFound"] = "FormNotFound";
    PaymentIntentError["CardDeclined"] = "CardDeclined";
    PaymentIntentError["InsufficientCapabilitiesForTransfer"] = "InsufficientCapabilitiesForTransfer";
    PaymentIntentError["InsufficientFunds"] = "InsufficientFunds";
})(PaymentIntentError || (exports.PaymentIntentError = PaymentIntentError = {}));
var EditMyProfileError;
(function (EditMyProfileError) {
    EditMyProfileError["EmailAlreadyUsed"] = "EmailAlreadyUsed";
})(EditMyProfileError || (exports.EditMyProfileError = EditMyProfileError = {}));
